"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Pillars() {
  const disciplines = [{
    ordinal: "01 — CRM",
    title: "Communication pipelines",
    body: "We architect the digital nervous system of your business. By integrating automated CRM workflows, we ensure every lead is captured, nurtured, and converted without manual intervention, allowing you to focus on the physical craftsmanship of your trade."
  }, {
    ordinal: "02 — FSM",
    title: "Operation tracking",
    body: "Field Service Management is the backbone of your efficiency. We configure robust FSM platforms that track job progress, technician location, and material usage in real-time, providing the visibility needed to scale your operations with absolute precision."
  }, {
    ordinal: "03 — Finance",
    title: "Automated infrastructure",
    body: "We bridge the gap between field work and the back office. Our bookkeeping integrations automate invoicing, expense tracking, and payroll, ensuring your financial data is as accurate and reliable as the structures you build for your clients."
  }];
  const header = useRevealOnScroll<HTMLDivElement>();
  const col0 = useRevealOnScroll<HTMLDivElement>();
  const col1 = useRevealOnScroll<HTMLDivElement>();
  const col2 = useRevealOnScroll<HTMLDivElement>();
  const columnRefs = [col0, col1, col2];
  return <section data-section-id="10573" id="the-five-pillars" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-10 md:px-12 lg:px-16">
        {}
        <div ref={header.ref} className="grid grid-cols-4 md:grid-cols-12 gap-6 transition-all duration-500 ease-out" style={{
        opacity: header.isVisible ? 1 : 0,
        transform: header.isVisible ? "translateY(0)" : "translateY(16px)",
        transitionTimingFunction: "cubic-bezier(0.2, 0.6, 0.2, 1)"
      }}>
          <div className="col-span-4 md:col-span-12">
            {}
            <div className="h-px bg-border transition-[width] duration-[400ms] ease-out" style={{
            width: header.isVisible ? "16.6667%" : "0%"
          }} aria-hidden="true" />
          </div>

          <h2 className="col-span-4 md:col-span-7 mt-6 font-default font-medium text-foreground" style={{
          fontSize: "clamp(2.25rem, 4vw, 4rem)",
          letterSpacing: "-0.02em",
          lineHeight: 1.02
        }}>
            Three pillars, one architecture.
          </h2>

          <p className="col-span-4 md:col-span-5 mt-8 text-foreground" style={{
          fontSize: "clamp(1.125rem, 1.3vw, 1.375rem)",
          letterSpacing: "-0.005em",
          lineHeight: 1.5,
          fontWeight: 400
        }}>
            CRM captures the intent. FSM manages the execution. Bookkeeping secures the profit. CSOS integrates these systems into a singular, high-performance engine.
          </p>
        </div>

        {}
        <div className="h-16 md:h-24" aria-hidden="true" />

        {}
        <div className="grid grid-cols-4 md:grid-cols-12 gap-6">
          {disciplines.map((item, i) => {
          const reveal = columnRefs[i];
          return <div data-index={i} key={i} ref={reveal.ref} className="col-span-4 md:col-span-4 flex flex-col" style={{
            opacity: reveal.isVisible ? 1 : 0,
            transform: reveal.isVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 500ms cubic-bezier(0.2, 0.6, 0.2, 1), transform 500ms cubic-bezier(0.2, 0.6, 0.2, 1)",
            transitionDelay: `${i * 80}ms`
          }}>
                {}
                {i > 0 && <div className="md:hidden h-px w-full bg-border mb-12" aria-hidden="true" />}

                {}
                <div className="font-mono text-primary" style={{
              fontSize: "0.875rem",
              fontWeight: 700,
              letterSpacing: "0.05em",
              lineHeight: 1.4
            }}>
                  {item.ordinal}
                </div>

                {}
                <div className="mt-4 h-px w-full bg-border" aria-hidden="true" />

                {}
                <h3 className="mt-8 font-default font-semibold text-foreground" style={{
              fontSize: "clamp(1.5rem, 2vw, 2rem)",
              letterSpacing: "-0.015em",
              lineHeight: 1.15
            }}>
                  {item.title}
                </h3>

                {}
                <p className="mt-4 text-foreground" style={{
              fontSize: "1rem",
              fontWeight: 400,
              lineHeight: 1.6
            }}>
                  {item.body}
                </p>

                {}
                <div className="mt-8">
                  <Link to="/ServicesPage" className="group inline-flex items-center gap-2 font-default font-semibold text-foreground" style={{
                fontSize: "1rem",
                letterSpacing: "0em"
              }}>
                    <span className="relative">
                      View infrastructure
                      <span className="pointer-events-none absolute left-0 -bottom-0.5 h-px w-full bg-primary origin-left scale-x-0 transition-transform duration-[160ms] ease-out group-hover:scale-x-100" aria-hidden="true" />
                    </span>
                    <span aria-hidden="true" className="inline-block transition-transform duration-[160ms] ease-out group-hover:translate-x-1">
                      →
                    </span>
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}